<template>
  <ol-tooltip :indicator="true">
    <template #activator="{ on }">
      <div
        class="text-no-wrap text-truncate job-id"
        v-on="on"
      >
        {{ jobId }}
      </div>
    </template>
    <span>{{ jobId }}: {{ jobName }}</span><!-- TODO needs tooltip for jobName -->
  </ol-tooltip>
</template>

<script>
export default {
  name: 'DocJobId',
  props: {
    jobId: { type: String, default: '' },
    jobName: { type: String, default: '' }
  }
}
</script>

<style lang="scss" scoped>
.job-id {
  width: 5rem;
}
</style>
